import { ReactNode } from 'react';
import styled from 'styled-components';
import { Card, flexColumn, FlexColumn } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';

export const Form = styled.form`
  ${flexColumn};
  gap: 16px;
  width: 100%;
`;

export const Frame = ({ children }: { children: ReactNode }) => (
  <Card>
    <FlexColumn sx={{ width: '100%' }}>{children}</FlexColumn>
  </Card>
);

export const FieldsContainer = styled(FlexColumn)`
  gap: 24px;
`;

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 13px;
  margin-bottom: 8px;
`;
